import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// MAX-3878 — Add Category modal.
export const styles = (theme: Theme) => ({
	actions: {
		padding: "16px 24px",
	},
	field: {
		marginTop: 8,
	},
} satisfies Record<string, CSSObject>);
